import React from 'react';
import EcoAssociation10Class2025 from 'views/EcoAssociation10Class2025';

const AccountGeneralPage = () => {
  return <EcoAssociation10Class2025/>;
};

export default AccountGeneralPage;